import type { GetAuthUsersResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetAuthUsersQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAuthUsersDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, type StrictMappedGraphQLSelection } from 'src/utils';

const mapTrpcUserToGraphQL = (
  user: GetAuthUsersResponseRow
): StrictMappedGraphQLSelection<GetAuthUsersQuery['auth_user'][number]> => ({
  ...user,
  customRoles: (user.customRoles ?? [])
    .filter((customRole) => customRole.customRole != null)
    .map((customRole) => ({ ...customRole, role: customRole.customRole! })),
  userGroupUsers: (user.userGroupUsers ?? [])
    .filter((userGroupUser) => userGroupUser.userGroups != null)
    .map((userGroupUser) => ({
      ...userGroupUser,
      userGroups: userGroupUser.userGroups!,
    })),
});

const mapTrpcUsersToGraphQL = (
  trpcData: GetAuthUsersResponseRow[]
): StrictMappedGraphQLSelection<GetAuthUsersQuery> => ({
  auth_user: trpcData.map(mapTrpcUserToGraphQL),
  auth_user_aggregate: { aggregate: { count: trpcData.length } },
});

type UseGetAuthUsersArgs = Record<string, never>;

export const useGetAuthUsers = createQueryHook<
  UseGetAuthUsersArgs,
  GetAuthUsersResponseRow[],
  GetAuthUsersQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.user.users.queryOptions(),
  mapTrpcDataToGraphQL: mapTrpcUsersToGraphQL,
  graphqlDocument: GetAuthUsersDocument,
  graphqlVariables: () => ({
    where: {
      _or: [
        { RoleKey: { _neq: 'ThirdPartyRespondent' } },
        { RoleKey: { _is_null: true } },
      ],
    },
  }),
});
